import Grid from "@mui/material/Grid";

import {
  NearExpirData,
  ExpiredItemData,
  BinwiseStockOverDueData,
  BinwiseStockPaidData,
  BinwiseStockDueDetailData,
  ItemswiseData,
} from "../WMSStockReportAction.jsx";
import {
  CmpTypographyField,
  CmpRadioButton,
  CmpDatePickerField,
  CmpSelectField,
} from "../../../Component/Common/ToolBox/ToolBox.js";

export default function WmsContent({
  DetailReportRadioBtn,
  selectedOption,
  sDueData,
  sExpiryData,
  sBufferObj,
  fNearExpiryDate,
  fNearExpiryDropdown,
  fExpiredItemDate,
  fExpiredItemDropdown,
  fBinwiseStockOverDueDropdown,
  fBinwiseStockPaidDropdown,
  fBinwiseStockDueDetailDropdown,
  fItemwiseDropdown,
  xtitle = "",
  //View
  DetailViewReportRadioBtn,
  selectedOptionView,
}) {
  return (
    <form className="" id="WMSStockReportContent">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={xtitle}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="BINWISE_DETAIL"
            label="Binwise Detail"
            checked={selectedOption === "BINWISE_DETAIL"}
            onChange={DetailReportRadioBtn}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="BIN_LEDGER"
            label="Bin Ledger"
            checked={selectedOption === "BIN_LEDGER"}
            onChange={DetailReportRadioBtn}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="BATCHWISE_DETAIL"
            label="Batchwise Detail"
            checked={selectedOption === "BATCHWISE_DETAIL"}
            onChange={DetailReportRadioBtn}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="DROPID"
            label="DropId Detail"
            checked={selectedOption === "DROPID"}
            onChange={DetailReportRadioBtn}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={4}>
              <CmpRadioButton
                value="NR_EXP"
                label="Near Expiry"
                checked={selectedOption === "NR_EXP"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "NR_EXP"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpDatePickerField
                xValue={sBufferObj.NearExpiryDate}
                xOnChange={fNearExpiryDate}
                xName={"NearExpiryDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "NR_EXP"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.NearExpiryDropdown}
                xOnChange={fNearExpiryDropdown}
                xName={"NearExpiryDropdown"}
                xData={NearExpirData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={4}>
              <CmpRadioButton
                value="EXP_ITEM"
                label="Expired Item"
                checked={selectedOption === "EXP_ITEM"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "EXP_ITEM"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpDatePickerField
                xValue={sBufferObj.ExpiredItemDate}
                xOnChange={fExpiredItemDate}
                xName={"ExpiredItemDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "EXP_ITEM"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.ExpiredItemDropdown}
                xOnChange={fExpiredItemDropdown}
                xName={"ExpiredItemDropdown"}
                xData={ExpiredItemData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="ITEM_LEDGER"
            label="Item Ledger"
            checked={selectedOption === "ITEM_LEDGER"}
            onChange={DetailReportRadioBtn}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6}>
              <CmpRadioButton
                value="STK_BIN_OD"
                label="Binwise Stock - Over Due"
                checked={selectedOption === "STK_BIN_OD"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "STK_BIN_OD"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.BinwiseStockOverDueDropdown}
                xOnChange={fBinwiseStockOverDueDropdown}
                xName={"BinwiseStockOverDueDropdown"}
                xData={BinwiseStockOverDueData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6}>
              <CmpRadioButton
                value="STK_PAID"
                label="Binwise Stock - Paid"
                checked={selectedOption === "STK_PAID"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "STK_PAID"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.BinwiseStockPaidDropdown}
                xOnChange={fBinwiseStockPaidDropdown}
                xName={"BinwiseStockPaidDropdown"}
                xData={BinwiseStockPaidData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={6}>
              <CmpRadioButton
                value="STK_DUE"
                label="Binwise Stock - Due Detail"
                checked={selectedOption === "STK_DUE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "STK_DUE"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.BinwiseStockDueDetailDropdown}
                xOnChange={fBinwiseStockDueDetailDropdown}
                xName={"BinwiseStockDueDetailDropdown"}
                xData={BinwiseStockDueDetailData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={12} sm={12} md={4}>
              <CmpRadioButton
                value="ITEMSWISE"
                label="Itemswise"
                checked={selectedOption === "ITEMSWISE"}
                onChange={DetailReportRadioBtn}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              className={
                selectedOption === "ITEMSWISE"
                  ? ""
                  : "hide-radio-buttonStockReport"
              }
            >
              <CmpSelectField
                xLabelText="NearExpiry"
                xValue={sBufferObj.ItemwiseDropdown}
                xOnChange={fItemwiseDropdown}
                xName={"ItemwiseDropdown"}
                xData={ItemswiseData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
                // xOnKeyUp={xKeyIInboundGrn}
              />
            </Grid>
          </Grid>
        </Grid>
        {/* <Grid item xs={12} sm={12} md={12}>
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"View"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="Grid"
            label="Grid"
            checked={selectedOptionView === "Grid"}
            onChange={DetailViewReportRadioBtn}
            xDisabled={
              selectedOption == "BIN_LEDGER" || selectedOption == "ITEM_LEDGER"
                ? true
                : false
            }
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <CmpRadioButton
            value="Report"
            label="Report"
            checked={selectedOptionView === "Report"}
            onChange={DetailViewReportRadioBtn}
            xDisabled={
              selectedOption === "BIN_LEDGER" ||
              selectedOption === "ITEM_LEDGER"
                ? true
                : false
            }
          />
        </Grid> */}
      </Grid>
    </form>
  );
}
